function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? Object(arguments[r]) : {}, o = Object.keys(t); "function" == typeof Object.getOwnPropertySymbols && o.push.apply(o, Object.getOwnPropertySymbols(t).filter(function (e) { return Object.getOwnPropertyDescriptor(t, e).enumerable; })), o.forEach(function (r) { _defineProperty(e, r, t[r]); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useEffect, useRef } from 'react';
import styles from './Icon.module.scss';
import cs from 'classnames';
import whitelistProps from '../../utils/whitelistProps';
var whitelist = whitelistProps();
var getOr = function getOr(defaultValue) {
  return function (value) {
    return typeof value === 'undefined' ? defaultValue : value;
  };
};
var getHeight = getOr('auto');
var getWidth = getOr('1rem');
var getLegacyDimension = getOr(16);
export default function Icon(_ref) {
  var width = _ref.width,
    height = _ref.height,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    children = _ref.children,
    _ref$legacy = _ref.legacy,
    legacy = _ref$legacy === void 0 ? false : _ref$legacy,
    Icon = _ref.icon,
    style = _ref.style,
    attrs = _objectWithoutProperties(_ref, ["width", "height", "className", "children", "legacy", "icon", "style"]);
  var styl = legacy ? style : _objectSpread({}, style, {
    width: getWidth(width),
    height: getHeight(height)
  });
  var ref = useRef(null);
  useEffect(function () {
    var current = ref.current;
    var svg = current && current.getElementsByTagName('svg')[0];
    if (svg) {
      if (legacy) {
        svg.setAttribute('width', String(getLegacyDimension(width)));
        svg.setAttribute('height', String(getLegacyDimension(height)));
        svg.style.display = 'block';
      } else {
        var classNameArray = (svg.getAttribute('class') || '').split(' ');
        if (!classNameArray.includes(styles.modern)) {
          svg.setAttribute('class', classNameArray.concat(styles.modern).join(' '));
        }
      }
    }
  }, [width, height, legacy]);
  return /*#__PURE__*/React.createElement("span", Object.assign({
    ref: ref,
    className: cs(styles.icon, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, styles.legacy, legacy), styles['legacy--base'], legacy && !className), '_dm-icon--legacy', legacy), className, className)),
    style: styl,
    "aria-hidden": true
  }, whitelist(attrs)), Icon ? /*#__PURE__*/React.createElement(Icon, null) : children);
}